import Tooltip from "@mui/material/Tooltip"
import { useEffect, useRef } from "react"

type Props = {
  value: string
  onBlur: (value: string) => void
  onInputChange: (value: string) => void
  style?: React.CSSProperties
  error?: string
}
/** Only blur event is supported and it provides the value of the input at the time of blur
 */
export function SeamlessInput({
  value,
  onBlur,
  onInputChange,
  style,
  error,
}: Props) {
  const elRef = useRef<HTMLSpanElement>(null)

  // focus and select all text when mounted
  useEffect(() => {
    const el = elRef.current
    console.log(elRef.current, "focusing")
    if (el) {
      el.focus()
      const range = document.createRange()
      range.selectNodeContents(el)
      const sel = window.getSelection()
      sel?.removeAllRanges()
      sel?.addRange(range)
    }
  }, [])

  function handleKeyDown(ev: React.KeyboardEvent) {
    if (ev.key === "Enter") {
      ev.preventDefault()
      ev.stopPropagation()
      if (elRef.current) {
        elRef.current.blur()
      }
    } else {
      if (elRef.current) {
        onInputChange(elRef.current.innerText)
      }
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  function handleBlur(ev: React.FocusEvent) {
    if (elRef.current) {
      onBlur(elRef.current.innerText)
    }
  }
  return (
    <Tooltip title={error}>
      <span
        ref={elRef}
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
        onKeyUp={(e) => onInputChange(e.currentTarget.innerText)}
        style={{
          ...style,
          outline: error ? "1px dotted red" : "1px dotted #aaa",
        }}
        contentEditable
        suppressContentEditableWarning
        spellCheck={false}
      >
        {value}
      </span>
    </Tooltip>
  )
}
